import { ToastStore } from '@stores/models/store';
import * as Reducers from '@stores/reducers/Reducers';
import { Dispatch } from 'redux';

export const toast =
  (toast: Partial<ToastStore>) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: Reducers.ADD_TOAST, payload: toast });
  };

export const removeToast =
  (toast: ToastStore) =>
  (dispatch: Dispatch): void => {
    dispatch({ type: Reducers.REMOVE_TOAST, payload: toast });
  };
